/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable import/prefer-default-export */
import { coursesConstants } from '../constants/coursesConstants';
import { edusignServices } from '../services/edusignServices';

function abortCoursesRequest() {
  return (dispatch, getState) => {
    dispatch(failure('Abort request'));
  };
  function failure(error) { return { type: coursesConstants.GET_COURSES_FAILURE, error }; }
}

function getCourses() {
  return (dispatch, getState) => {
    dispatch(request());
    edusignServices.getAllCourses()
      .then(
        (courses) => {
          dispatch(success(courses));
        },
        (error) => {
          dispatch(failure(error.toString()));
        },
      );
  };

  function request(courses) { return { type: coursesConstants.GET_COURSES_REQUEST, courses }; }
  function success(courses) { return { type: coursesConstants.GET_COURSES_SUCCESS, courses }; }
  function failure(error) { return { type: coursesConstants.GET_COURSES_FAILURE, error }; }
}

function getCoursesByProfessor(email) {
  return (dispatch, getState) => {
    dispatch(request());
    edusignServices.getTeacher(email)
      .then((teacherEdusign) => {
        edusignServices.getCoursesByProfessorId(teacherEdusign.ID)
          .then(
            (courses) => {
              dispatch(success(courses));
            },
            (error) => {
              dispatch(failure(error.toString()));
            },
          );
      })
      .catch((err) => dispatch(failure(err.toString())));
  };

  function request(courses) { return { type: coursesConstants.GET_COURSES_REQUEST, courses }; }
  function success(courses) { return { type: coursesConstants.GET_COURSES_SUCCESS, courses }; }
  function failure(error) { return { type: coursesConstants.GET_COURSES_FAILURE, error }; }
}

function getCoursesByStudent(email) {
  return (dispatch, getState) => {
    dispatch(request());
    edusignServices.getStudent(email)
      .then((studentEdusign) => {
        edusignServices.getCoursesByStudentId(studentEdusign.ID)
          .then(
            (courses) => {
              dispatch(success(courses));
            },
            (error) => {
              dispatch(failure(error.toString()));
            },
          );
      })
      .catch((err) => dispatch(failure(err.toString())));
  };

  function request(courses) { return { type: coursesConstants.GET_COURSES_REQUEST, courses }; }
  function success(courses) { return { type: coursesConstants.GET_COURSES_SUCCESS, courses }; }
  function failure(error) { return { type: coursesConstants.GET_COURSES_FAILURE, error }; }
}

function unsetCourses() {
  return (dispatch, getState) => {
    // sessionStorage.removeItem('courses');
    dispatch({ type: coursesConstants.UNSET_COURSES });
  };
}

function setCourses(courses) {
  return (dispatch, getState) => {
    // sessionStorage.setItem('courses', JSON.stringify(courses));
    dispatch({ type: coursesConstants.SET_COURSES, courses });
  };
}

export const coursesActions = {
  getCourses,
  unsetCourses,
  setCourses,
  getCoursesByStudent,
  getCoursesByProfessor,
  abortCoursesRequest,
};
